import { type AdverseEventsFormValues } from '#app/routes/mocra+/_form+/adverse-events/form.ts'
import { type CompanyFormValues } from '#app/routes/mocra+/_form+/company.tsx'
import { type FacilitiesFormValues } from '#app/routes/mocra+/_form+/facilities.tsx'
import { loadSection } from '#app/routes/mocra+/_form+/intake-storage.ts'
import { type LabelGovernanceFormValues } from '#app/routes/mocra+/_form+/label-governance.tsx'
import { type PersonalInfoFormValues } from '#app/routes/mocra+/_form+/personal-info.tsx'
import { type PoliciesReferencesFormValues } from '#app/routes/mocra+/_form+/policies-references.tsx'
import { type PrimaryContactsFormValues } from '#app/routes/mocra+/_form+/primary-contacts.tsx'
import { type ProductsFormValues } from '#app/routes/mocra+/_form+/products.tsx'
import { type RecallPreparednessFormValues } from '#app/routes/mocra+/_form+/recall-preparedness.tsx'
import { type RecordsAccessFormValues } from '#app/routes/mocra+/_form+/records-access.tsx'
import { type RegulatoryMonitoringFormValues } from '#app/routes/mocra+/_form+/regulatory-monitoring.tsx'
import { type SuppliersTestingFormValues } from '#app/routes/mocra+/_form+/suppliers-testing.tsx'
import { type TrainingDocumentationFormValues } from '#app/routes/mocra+/_form+/training-documentation.tsx'

export type IntakeDraft = {
	personalInfo?: PersonalInfoFormValues
	company?: CompanyFormValues
	primaryContacts?: PrimaryContactsFormValues
	products?: ProductsFormValues
	facilities?: FacilitiesFormValues
	adverseEvents?: AdverseEventsFormValues
	suppliersTesting?: SuppliersTestingFormValues
	labelGovernance?: LabelGovernanceFormValues
	recordsAccess?: RecordsAccessFormValues
	recallPreparedness?: RecallPreparednessFormValues
	trainingDocumentation?: TrainingDocumentationFormValues
	regulatoryMonitoring?: RegulatoryMonitoringFormValues
	policiesReferences?: PoliciesReferencesFormValues
}

export type IntakeSectionKey = keyof IntakeDraft

export function loadIntakeDraft(): IntakeDraft {
	if (typeof window === 'undefined') return {}
	return {
		personalInfo:
			loadSection<PersonalInfoFormValues>('personalInfo') ?? undefined,
		company: loadSection<CompanyFormValues>('company') ?? undefined,
		primaryContacts:
			loadSection<PrimaryContactsFormValues>('primaryContacts') ?? undefined,
		products: loadSection<ProductsFormValues>('products') ?? undefined,
		facilities: loadSection<FacilitiesFormValues>('facilities') ?? undefined,
		adverseEvents:
			loadSection<AdverseEventsFormValues>('adverseEvents') ?? undefined,
		suppliersTesting:
			loadSection<SuppliersTestingFormValues>('suppliersTesting') ?? undefined,
		labelGovernance:
			loadSection<LabelGovernanceFormValues>('labelGovernance') ?? undefined,
		recordsAccess:
			loadSection<RecordsAccessFormValues>('recordsAccess') ?? undefined,
		recallPreparedness:
			loadSection<RecallPreparednessFormValues>('recallPreparedness') ??
			undefined,
		trainingDocumentation:
			loadSection<TrainingDocumentationFormValues>('trainingDocumentation') ??
			undefined,
		regulatoryMonitoring:
			loadSection<RegulatoryMonitoringFormValues>('regulatoryMonitoring') ??
			undefined,
		policiesReferences:
			loadSection<PoliciesReferencesFormValues>('policiesReferences') ??
			undefined,
	}
}
